import { render, staticRenderFns } from "./tousujianyi.vue?vue&type=template&id=56bb81a0&scoped=true&"
import script from "./tousujianyi.vue?vue&type=script&lang=js&"
export * from "./tousujianyi.vue?vue&type=script&lang=js&"
import style0 from "./tousujianyi.vue?vue&type=style&index=0&id=56bb81a0&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56bb81a0",
  null
  
)

export default component.exports